/* Imágenes rotativas del mega menú.
   Mismo patrón que el carrusel de caras de la prueba social
   (lv-psocial.js): un fondo de hasta unas quince fotos, siempre dos
   huecos fijos en el DOM, y cada 6 segundos se desliza la ventana un
   puesto con un cruce suave. Sólo se carga cuando main-product... aquí
   header-mega-menu.liquid ya decidió que hay más de dos fotos: con dos
   o menos no hay entre qué rotar. */
(() => {
  const INTERVALO = 6000;

  document.querySelectorAll('[data-lv-mega-rotativo]').forEach((caja) => {
    const fuente = caja.querySelector('[data-lv-mega-fuente]');
    const imgs = [...caja.querySelectorAll('[data-lv-mega-img]')];
    if (!fuente || !imgs.length) return;

    let pool;
    try {
      pool = JSON.parse(fuente.textContent);
    } catch {
      return;
    }
    if (!Array.isArray(pool) || pool.length <= imgs.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Precarga todo el fondo de fotos desde el principio. Sin esto, el
    // cruce se pone a esperar a que llegue la imagen nueva con la opacidad
    // ya bajada -un hueco vacío en vez de una transición limpia-; cuando ya
    // está en la caché del navegador, el cambio de src es instantáneo y el
    // cruce se ve de verdad.
    pool.forEach((url) => {
      new Image().src = url;
    });

    let indice = imgs.length;
    let temporizador = null;

    const avanzar = () => {
      imgs.forEach((img) => img.classList.add('lv-mega__imagen-img--cambiando'));
      window.setTimeout(() => {
        imgs.forEach((img) => {
          img.src = pool[indice % pool.length];
          indice += 1;
          img.classList.remove('lv-mega__imagen-img--cambiando');
        });
      }, 220);
    };

    const iniciar = () => {
      if (temporizador) return;
      temporizador = window.setInterval(avanzar, INTERVALO);
    };
    const parar = () => {
      window.clearInterval(temporizador);
      temporizador = null;
    };

    // Pausado mientras el panel del menú está cerrado: nadie lo ve, y así no
    // se gasta red ni CPU en una pestaña que puede llevar horas abierta.
    const details = caja.closest('details');
    if (details) {
      const revisar = () => (details.open ? iniciar() : parar());
      details.addEventListener('toggle', revisar);
      revisar();
    } else {
      iniciar();
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) parar();
      else if (!details || details.open) iniciar();
    });
  });
})();
